"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishToExtension = publishToExtension;

/**
 * Publish to https://code.amazon.com/packages/KatalMetricsExtension
 * The extension injects a global __KATAL_METRICS_EXTENSION__ object with a
 * `publish` method.
 */
function publishToExtension(metric, context) {
  if (typeof window !== 'undefined' && window.__KATAL_METRICS_EXTENSION__) {
    window.__KATAL_METRICS_EXTENSION__.publish(metric, context.getFields());
  }
}